import cHeader from '@/components/Header/Headernew.vue';
// import cHeader from '@/components/Header/Header.vue';
import cFooter from '@/components/Footer/Footer.vue';

export default {
  components: {
    cHeader,
    cFooter
  },
  data() {
    return {
      sendTo: "All",
      message: "",
      username: "",
      userList: null,
      messageList: null,
      websocket: null,

      screen: {
        height: document.documentElement.clientHeight,
        width: document.documentElement.clientWidth
      },
      isLogin: true,
      isMe: true,
      isHome: true,
      canBack: false,
      backTo: -1,
      messageNum:0,
      url:{
        num:SZH.assets.api+'/Custom/GetCustomMessageQuantity'
      },
      accountname:'',

    //  xinzeng
      ishead:true,
      isfoot:true,

    }
  },
  computed: {
    view() {
      return {
        height: this.screen.height,
        width: this.screen.width
      }
    },
    isPhone() {
        return this.screen.width <= 450;
    },

  },
  mounted() {

    this.accountname = localStorage.getItem('ms_accountname');
    // 处理路由
    this.onRouteChange();

    // 监听屏幕尺寸
    const self = this;
    window.onresize = () => {
      return (() => {
        self.screen = {
          height: document.documentElement.clientHeight,
          width: document.documentElement.clientWidth
        }
      })();
    }

    this.username = localStorage.ms_customId;
    // this.openWebSocket();
    if(this.accountname){
      this.getNum();
    }
  },
  watch: {
    $route(val) {
      this.onRouteChange();
      this.accountname = localStorage.getItem('ms_accountname');
      if(this.accountname){
        this.getNum();
      }
    }
  },
  created(){

  },
  methods: {




    onRouteChange() {
      let self = this;
      if (self.$route.meta.isHome) {
        self.isHome = true;
      }
      else {
        self.isHome = false;
      }
      if (self.$route.meta.isMe) {
        self.isMe = true;
      }
      else {
        self.isMe = false;
      }
      if (self.$route.meta.isLogin) {
        self.isLogin = true;
      }
      else {
        self.isLogin = false;
        self.ishead = false;
        self.isfoot = false;
      }
      if (self.$route.meta.canBack){
        self.canBack = true;
      }
      else {
        self.canBack = false;
      }
      if (self.$route.meta.backTo){
        self.backTo = self.$route.meta.backTo;
      }
      else {
        self.backTo = -1;
      }
    },
    getNum(){
      var _this = this;
      _this.$http.post(_this.url.num,{
      }).then(result=>{
        if (result.State == 1) {
          _this.messageNum = result.Data.Quantity;
        } else if(result.State == 3) {
          _this.messageNum = 0;
        }
      },()=>{
        _this.$message.error('数据加载失败，请检查您的网络是否可用。');
      })
    },
    back(){
      this.$router.go(this.backTo);//返回上一层
    },
    openWebSocket: function () {
      let self = this;
      var isSupport = 'WebSocket' in window;
      if (!isSupport) {
        var message = self.formatMessage(new Date(), "系统消息", "当前浏览器不支持WebSocket");
        return;
      }
      this.websocket = new WebSocket(SZH.assets.ws+"/ws?username=" + this.username);
      //链接错误得回调方法
      this.websocket.onerror = function () {
        var message = self.formatMessage(new Date(), "系统消息", "WebSocket连接发生错误");
      };
      //连接成功建立的回调方法
      this.websocket.onopen = function () {
        var message = self.formatMessage(new Date(), "系统消息", "WebSocket连接成功");
        self.sendEvent("Joined");
      }
      //接收到消息的回调方法
      this.websocket.onmessage = function (event) {
        var entity = JSON.parse(event.data);
        console.log(entity);
        if (entity.Type == "Event") {
          var eventData = JSON.parse(entity.Message);
          self.userList = eventData.Data.filter(function (data) {
            return data != self.username;
          });
        } else {
          var message = self.formatMessage(entity.SendTime, entity.Sender, entity.Message);
          if(self.$refs.child !== undefined && self.$refs.child.orderRefresh !== undefined && entity.Type == 2){
            console.log('订单刷新');
            self.$refs.child.orderRefresh(entity.ObjectId)
          }

          // if(entity.Type == 2){
          //   console.log('订单刷新2');
          //   self.$refs.child.orderRefresh(entity.ObjectId)
          // }
          if(self.$refs.child !== undefined && self.$refs.child.onSavedBill !== undefined && entity.Type == 3){
            self.$refs.child.onSavedBill();
          }
          if(self.$refs.child !== undefined && self.$refs.child.refreshData !== undefined && entity.Type == 5){
            self.$refs.child.refreshData();
          }
          self.messageNum = self.messageNum+1;
          if(entity.Type != 5){
            self.$notify({
              title: entity.Title,
              message: message,
              position: 'bottom-right',
              duration: 0
            });
          }

        }
      }
      //连接关闭的回调方法
      this.websocket.onclose = function () {
        var message = self.formatMessage(new Date(), "系统消息", "WebSocket连接关闭");
      }
      //监听窗口关闭事件
      window.onbeforeunload = function () {
        if (self.websocket == null) {
          return;
        }
        self.closeWebSocket();
      }
    },
    closeWebSocket: function () {
      if (this.websocket == null) {
        return;
      }
      this.sendEvent("Leaved");
      this.websocket.close();
    },
    sendMessage: function () {
      if (this.websocket == null) {
        return;
      }
      this.websocket.send(JSON.stringify({
        "sender": this.username,
        "receiver": this.sendTo,
        "message": this.message,
        "sendTime": new Date().toISOString(),
      }));
      var message = this.formatMessage(new Date(), this.username, this.message);
      this.message = null;
    },
    sendEvent: function (eventName) {
      if (this.websocket == null) {
        return;
      }
      var eventData = JSON.stringify({
        "event": eventName,
        "data": null
      });
      this.websocket.send(JSON.stringify({
        "type": "event",
        "sender": this.username,
        "message": eventData,
        "sendTime": new Date().toISOString(),
      }));
    },
    formatMessage: function (sendTime, sender, message) {
      return new Date(sendTime).format("yyyy-MM-dd hh:mm:ss") + " - " + sender + " : " + message;
    },
    clearMessageList: function () {
      this.messageList = null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/Main/Main.js